import { render, staticRenderFns } from "./marksheetList.vue?vue&type=template&id=46158a01&scoped=true&"
import script from "./marksheetList.vue?vue&type=script&lang=js&"
export * from "./marksheetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46158a01",
  null
  
)

export default component.exports